module.exports = __webpack_public_path__ + "static/media/cancer-mediana.19d15644.jpg";